import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services';
@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // add auth header with jwt if user is logged in and request is to the api url
    const user = this.authService.userValue;
    const headers: any = {};
    const isLoggedIn = user && user.token;
    if (isLoggedIn) {
      headers['Authorization'] = `Bearer ${user.token}`; // example: custom header
    }

    if (user && user.isAdLogin) {
      headers['Auth'] = 'B2C_1A_TRUMINDSSIGNIN'; // example: custom header
    }

    request = request.clone({
      setHeaders: headers,
    });

    return next.handle(request);
  }
}
